import { Modal, ModalContent, ModalBody } from '@heroui/react';
import { parse } from 'node-html-parser';
import { useEffect, useMemo } from 'react';

import useEducation from '@/patient-app-common/hooks/useEducation';
import { combineEducationTopics } from '@/patient-app-common/helpers/education_helpers';
import { AppEvent } from '@/patient-app-common/types/ApplicationEvent';
import useSegment from '@/hooks/useSegment';

const EDUCATION_EVENT = 'Education Topic Viewed';

interface EduModalProps {
  event: AppEvent;
  isOpen: boolean;
  onClose: () => void;
  source: string;
}

export function EduModal({ event, isOpen, onClose, source }: EduModalProps) {
  const { allEducation } = useEducation();
  const { sendTrackEvent } = useSegment();

  useEffect(() => {
    if (!event || !isOpen) return;
    sendEventForTopics();
  }, [event, isOpen]);

  const sendEventForTopics = () => {
    const combinedTopic = combineEducationTopics(allEducation, event.edIds);

    if (!combinedTopic?.ids.length) return;

    combinedTopic.ids.forEach((id, index) => {
      sendTrackEvent(EDUCATION_EVENT, {
        id,
        title: combinedTopic.titles[index],
        source,
      });
    });
  };

  const HtmlContent = useMemo(() => {
    if (!allEducation.length || !event) {
      return <div />;
    }

    const { edIds } = event;

    const combinedTopic = combineEducationTopics(allEducation, edIds);

    if (!combinedTopic.html) return <div />;

    const root = parse(combinedTopic.html);
    const linkElements = root.querySelectorAll(
      'a[href*="seamless.md/#/education/"]'
    );
    linkElements.forEach((element) => {
      element.removeAttribute('target');
    });

    return (
      <div
        className="ed-v3"
        dangerouslySetInnerHTML={{ __html: root.toString() }}
      />
    );
  }, [allEducation, event]);

  return (
    <Modal isOpen={isOpen} onClose={onClose} scrollBehavior="inside" size="5xl">
      <ModalContent>
        <ModalBody>{HtmlContent}</ModalBody>
      </ModalContent>
    </Modal>
  );
}
